<template>
  <section class="warranty-financing">
    <h2>Warranty &amp; Financing</h2>
    <div class="cards">
      <article class="card">
        <p class="card-kicker">Built to last</p>
        <h3>50-Year Warranty Available</h3>
        <p>
          A new roof is a big investment, so ask about our 50-year warranty during your free estimate.
          We'll walk you through exactly what it covers before any work starts.
        </p>
        <ul>
          <li>Installed by a CertainTeed Shingle Master and TAMKO Pro Platinum contractor</li>
          <li>Licensed by the State of Michigan (#252400025)</li>
          <li>$1,000,000 general liability insurance</li>
        </ul>
      </article>

      <article class="card">
        <p class="card-kicker">Pay over time</p>
        <h3>Financing on Projects Over $3,000</h3>
        <p>
          Don't put off a roof that needs attention. Check your financing options online through our
          partner, Enhancify. Seeing your options uses a soft credit check that won't affect your credit score.
        </p>
        <button type="button" class="card-button" @click="openFinancing">Check financing options</button>
        <p class="fine-print">Rates and terms depend on the lender and your credit.</p>
      </article>
    </div>
  </section>
</template>

<script>
import { trackEvent } from '@/analytics';

export default {
  name: 'WarrantyFinancing',
  methods: {
    openFinancing() {
      trackEvent('financing_click', { location: 'warranty_financing' });
      window.open('https://www.enhancify.com/homes-roofing', '_blank', 'noopener');
    }
  }
};
</script>

<style scoped>
.warranty-financing {
  max-width: 1080px;
  margin: 0 auto;
  padding: 30px;
  text-align: center;
}

h2 {
  font-size: clamp(1.35rem, 2.5vw + 0.5rem, 2.2rem);
  color: #f1c40f;
  margin: 0 0 24px;
  padding-bottom: 10px;
  border-bottom: 3px solid #f1c40f;
  display: inline-block;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  text-align: left;
}

.card {
  background: rgba(255, 255, 255, 0.06);
  border-left: 5px solid #f1c40f;
  border-radius: 10px;
  padding: 26px 26px 24px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}

.card-kicker {
  margin: 0 0 6px;
  color: #f1c40f;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
}

h3 {
  margin: 0 0 12px;
  color: #fff;
  font-size: clamp(1.2rem, 1.2vw + 0.7rem, 1.45rem);
}

p {
  margin: 0 0 14px;
  color: #e8e8e8;
  line-height: 1.7;
  font-size: 1rem;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

li {
  position: relative;
  padding-left: 26px;
  color: #f5f5f5;
  line-height: 1.5;
}

li::before {
  content: '\2713';
  position: absolute;
  left: 0;
  top: 0;
  color: #f1c40f;
  font-weight: 900;
}

.card-button {
  align-self: flex-start;
  margin-top: auto;
  padding: 13px 24px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-radius: 10px;
  background: linear-gradient(135deg, #1656a8 0%, #2b7de5 60%, #69aef8 100%);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.34), 0 0 0 1px rgba(255, 255, 255, 0.08) inset;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.22s ease, box-shadow 0.22s ease, filter 0.22s ease;
}

.card-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.32), 0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  filter: brightness(1.05);
}

.card-button:focus-visible {
  outline: 3px solid #f1c40f;
  outline-offset: 2px;
}

.fine-print {
  margin: 10px 0 0;
  font-size: 0.85rem;
  color: #c9d3de;
}

@media (max-width: 760px) {
  .warranty-financing {
    padding: 24px 16px;
  }

  .cards {
    grid-template-columns: 1fr;
  }

  .card {
    padding: 22px 18px;
  }
}
</style>
